export default [
    {
        name: 'AWB',
        value: 's_mawb',
        s_mawb: true
    },
    {
        name: 'Status',
        value: 's_status'
    },
    {
        name: 'Modified',
        value: 't_modified',
        datetime: true,
        utc: true
    },
    {
        name: 'Modified by',
        value: 's_modified_by',
        email: true
    },
    {
        name: 'Pieces',
        value: 'i_pieces'
    },
    {
        name: 'Weight',
        value: 'i_weight'
    },
    {
        name: 'Origin',
        value: 's_origin'
    },
    {
        name: 'Destination',
        value: 's_destination'
    }
];